export class DateFormatException extends Error {
  constructor(message: string) {
    super(message);
  }
}
